<script>

  import CountrySelector from "./CountrySelector.svelte"
  export let allData;
  export let selectedCountries;
  export let isMobile;

  const { countries, ports } = allData
  const numPorts = ports.length
</script>

{#if isMobile }
<table class="interactive__table interactive__table--small" cellpadding="0" cellspacing="0">
  <thead>
    <tr>
      {#each selectedCountries as country, index}
        <th>
          <CountrySelector
            bind:selectedCountries
            numCountry={index}
            {countries}
          />
        </th>
      {/each}
    </tr>
  </thead>
  <tbody>
    <tr>
      <th  class="interactive__subheading" colspan="2">Overall Economy Score</th>
    </tr>
    <tr>
      {#each selectedCountries as country}
      <td>{ countries.get(country).value_formatted }</td>
      {/each}
    </tr>
    <tr>
      <th  class="interactive__subheading" colspan="2">Most Connected Port</th>
    </tr>
    <tr>
      {#each selectedCountries as country}
      <td>
        <div>{ countries.get(country).most_port.port }</div>
        <ul class="port-values" role="list">
          <li><span>Rank:</span> { countries.get(country).most_port.rank }</li>
          <li><span>Score:</span> { countries.get(country).most_port.value_formatted }</li>
        </ul>
      </td>
      {/each}
    </tr>
    <tr>
      <th  class="interactive__subheading" colspan="2">Least Connected Port</th>
    </tr>
    <tr>
      {#each selectedCountries as country}
      <td>
        <div>{ countries.get(country).least_port.port }</div>
        <ul class="port-values" role="list">
          <li><span>Rank:</span> { countries.get(country).least_port.rank }</li>
          <li><span>Score:</span> { countries.get(country).least_port.value_formatted }</li>
        </ul>
      </td>
      {/each}
    </tr>
    <tr>
      <th  class="interactive__subheading" colspan="2">Number of Ports in Top {numPorts}</th>
    </tr>
    <tr>
      {#each selectedCountries as country}
      <td>{ countries.get(country).num_ports }</td>
      {/each}
    </tr>
  </tbody>
</table>
{:else}
<table class="interactive__table interactive__table--large" cellpadding="0" cellspacing="0">
  <thead>
    <tr class="interactive__subheading">
      <th></th>
      <th>Overall Economy Score</th>
      <th>Most Connected Port</th>
      <th>Least Connected Port</th>
      <th>Number of Ports in Top {numPorts}</th>
    </tr>
  </thead>
  <tbody>
    {#each selectedCountries as country, index}
    <tr>
      <th class="interactive__subheading">
        <CountrySelector
          bind:selectedCountries
          numCountry={index}
          {countries}
        />
      </th>
      <td>{ countries.get(country).value_formatted }</td>
      <td>
        <div>{ countries.get(country).most_port.port }</div>
        <ul class="port-values" role="list">
          <li><span>Rank:</span> { countries.get(country).most_port.rank }</li>
          <li><span>Score:</span> { countries.get(country).most_port.value_formatted }</li>
        </ul>
      </td>
      <td>
        <div>{ countries.get(country).least_port.port }</div>
        <ul class="port-values" role="list">
          <li><span>Rank:</span> { countries.get(country).least_port.rank }</li>
          <li><span>Score:</span> { countries.get(country).least_port.value_formatted }</li>
        </ul>
      </td>
      <td>{ countries.get(country).num_ports }</td>
    </tr>
    {/each}
  </tbody>
</table>
{/if}

<style type="text/scss">
  @import "../scss/custom/_table.scss";
</style>